export const RULE_TYPE = { AUTOMATED: "AUTOMATED", MANUAL: "MANUAL" };
